<template>
    <div class="content-wrap">
        <section class="section section-highlight content-section-01">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <h2 class="headline_h1 bordered-heading">Auto <span class="make-red">verkaufen</span> - lokal oder online</h2>
                    </div>
                </div>
                <div class="row middle-md">
                    <div class="col-xs-12 col-md-6 col-gi-5 col-gi-offset-1">
                        <div class="sub-section">
                            <h3 class="sub-title">
                                <i class="fa fa-map-marker"></i>
                                Lokal verkaufen
                            </h3>

                            <ul>
                                <li><strong>Bequem:</strong> Wunschtermin mit einem Klick online buchen</li>
                                <li><strong>Sicher:</strong> kein Risiko dank geprüfter PKW.de-Partnerhändler</li>
                                <li><strong>Sofort:</strong> Geld vor Ort in bar oder per Sofortüberweisung</li>
                            </ul>

                            <div class="action-block">
                                <button class="text-wrapper__btn" @click="makeRedirect(true)">
                                    <i class="fa fa-map-marker"></i>
                                    Preisbewertung erhalten <i class="fas fa-arrow-right" />
                                </button>
                                <a class="text-button" href="/auto-verkaufen/lokal" title="Lokal verkaufen">mehr erfahren</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 image-col">
                        <img src="../assets/base/auto_verkaufen_lokal.png" alt="Auto lokal verkaufen" />
                    </div>
                </div>
                <div class="row middle-md">
                    <div class="col-md-6 col-gi-5 col-gi-offset-1 image-col">
                        <img src="../assets/base/auto_verkaufen_online.png" alt="Auto online Verkaufen" />
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="sub-section">
                            <h3 class="sub-title">
                                <i class="fa fa-couch"></i>
                                Online verkaufen
                            </h3>

                            <ul>
                                <li><strong>Bequem:</strong> alles von der Couch erledigen</li>
                                <li><strong>Sicher:</strong> geprüfte PKW.de-Partnerhändler</li>
                                <li><strong>Stressfrei:</strong> Höchstgebot ohne lästiges Nachverhandeln </li>
                            </ul>

                            <div class="action-block">
                                <button class="text-wrapper__btn" @click="makeRedirect(false)">
                                    <i class="fa fa-couch"></i>
                                    Preisbewertung erhalten <i class="fas fa-arrow-right" />
                                </button>
                                <a class="text-button" href="/auto-verkaufen/online" title="Online verkaufen">mehr erfahren</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section content-section-02">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 text-wrapper">
                        <h2 class="headline_h1 bordered-heading margin-bottom">Auto verkaufen: <br/><span class="make-red">So funktioniert es</span></h2>
                    </div>
                </div>
                <div class="row middle-md">
                    <div class="col-xs-12 col-md-6 col-gi-5 col-gi-offset-1 image-col">
                        <img src="../assets/base/local-verkaufen-img.jpeg" alt="Lokal verkaufen" class="section-img" />
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="sub-section sub-section-01">
                            <h3 class="sub-title">
                                <i class="fa fa-map-marker"></i>
                                Lokal verkaufen
                            </h3>

                            <ol>
                                <li>Preisbewertung in 1 Minute erhalten </li>
                                <li>Termin bei PKW.de-Ankaufstation-Partner in der Nähe buchen</li>
                                <li>Vor Ort Auto begutachten lassen und Angebot bekommen</li>
                                <li>Auto verkaufen und Geld in bar oder per Sofortüberweisung erhalten</li>
                                <li>Abmeldung übernimmt der Händler</li>
                            </ol>

                            <div class="action-block text-only">
                                <a class="text-button" href="/auto-verkaufen/lokal" title="Lokal verkaufen">mehr erfahren</a>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="row middle-md">
                    <div class="col-xs-12 col-md-6 col-gi-5 col-gi-offset-1">
                        <div class="sub-section sub-section-02">
                            <h3 class="sub-title">
                                <i class="fa fa-couch"></i>
                                Online verkaufen
                            </h3>

                            <ol>
                                <li>Preisbewertung in 1 Minute erhalten</li>
                                <li>Fahrzeugdaten, Zustand und Bilder erfassen</li>
                                <li>Bei Bedarf begutachtet ein TÜV-Gutachter dein Auto direkt bei dir zu Hause</li>
                                <li>Mindestpreis und Auktionsdauer festlegen, Partnerhändler bieten auf dein Auto </li>
                                <li>Wenn du das Gebot annimmst, kümmert sich der Händler um Bezahlung, Abholung und Abmeldung</li>
                            </ol>

                            <div class="action-block text-only">
                                <a class="text-button" href="/auto-verkaufen/online" title="Online verkaufen">mehr erfahren</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6 image-col">
                        <img src="../assets/base/online-verkaufen-img.jpeg" alt="Online verkaufen" class="section-img" />
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-highlight content-section-03">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <h2 class="headline_h1 bordered-heading margin-bottom">Auto verkaufen: <span class="make-red">Deine Vorteile im Vergleich</span></h2>

                        <div class="table ratings">
                            <div class="table-row">
                                <div class="table-cell"></div>
                                <div class="table-cell head-cell local">
                                    <i class="fa fa-map-marker"></i>
                                    Lokal
                                </div>
                                <div class="table-cell head-cell online">
                                    <i class="fa fa-couch"></i>
                                    Online
                                </div>
                            </div>

                            <div class="table-row">
                                <div class="table-cell main-cell">
                                    <i class="fa fa-clock"></i>
                                    Schnelligkeit
                                </div>
                                <div class="table-cell">
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                </div>
                                <div class="table-cell">
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star fa-outlined"></i>
                                    <i class="fa fa-star fa-outlined"></i>
                                </div>
                            </div>
                            
                            <div class="table-row">
                                <div class="table-cell main-cell">
                                    <i class="fa fa-lock"></i>
                                    Sicherheit
                                </div>
                                <div class="table-cell">
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                </div>
                                <div class="table-cell">
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                </div>
                            </div>

                            <div class="table-row">
                                <div class="table-cell main-cell">
                                    <i class="fa fa-couch"></i>
                                    Bequemlichkeit
                                </div>
                                <div class="table-cell">
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star fa-outlined"></i>
                                </div>
                                <div class="table-cell">
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </section>
        <section class="section content-section-04">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <h2 class="headline_h1 bordered-heading margin-bottom">Nur Preis wissen</h2>

                        <sell-price-widget light></sell-price-widget>
                    </div>
                </div>
            </div>
            
        </section>
        <section class="section section-highlight content-section-04">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <ContactForm />
                    </div>
                </div>
            </div>
            
        </section>
        <section class="section content-section-05">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <h2 class="headline_h2 bordered-heading margin-bottom">Auto verkaufen: bequem und sicher bei PKW.de</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                        <p>Schnell, bequem, sicher und kostenlos das alte Auto zu verkaufen, ist kein Problem. Wir brauchen nur Marke, Modell, Erstzulassung und ein paar Angaben zu deinem Fahrzeug. Schon ermitteln wir in unter einer Minute den <strong>aktuellen Marktwert deines Gebrauchtwagens</strong>. Die Genauigkeit unserer Marktwerte sind vom TÜV Rheinland untersucht und zertifiziert worden.</p>
                        <h3>Mein Auto verkaufen? Meine Wahl!</h3>
                        <p>Du entscheidest – entweder verkaufst du direkt vor Ort an einen PKW.de-Partner mit <a href="/auto-verkaufen/lokal/" title="Ankaufstation">Ankaufstation</a>, oder ganz bequem im <a href="/auto-verkaufen/online/" title="Online-Verkauf">Online-Verkauf</a> von zu Hause. Beides ist bequem und sicher, PKW.de arbeitet nur mit überprüften Partnerhändlern zusammen.</p>
                        <p>Beim Verkauf an eine <a href="/auto-verkaufen/lokal/" title="PKW.de-Ankaufstation">PKW.de-Ankaufstation</a> buchst du online einen Termin und fährst mit dem Auto zu einem Partnerhändler ganz in deiner Nähe. Vor Ort wird das Auto begutachtet und du erhältst ein Angebot. Wenn du verkaufen möchtest, erhältst du das Geld in bar oder per Sofortüberweisung. Die Abmeldung übernimmt der Händler.</p>
                        <p>Möchtest du lieber bequem von <a href="/auto-verkaufen/online/" title="zuhause aus verkaufen">zuhause aus verkaufen</a>, erstellst du mit wenigen Klicks ein Exposé und lädst Bilder von deinem Auto hoch. Bei Bedarf kommt ein Gutachter zu dir und schaut sich dein Auto an. Zusammen mit unseren PKW.de-Experten legst du einen <strong>Mindestpreis</strong>, eine <strong>Auktionslaufzeit</strong> und optional einen <strong>Sofortkauf-Preis</strong> fest. Händler aus ganz Deutschland können jetzt auf dein Auto bieten – am Ende entscheidest du, ob du zum <strong>Höchstpreis verkaufen</strong> möchtest. Stimmst du zu, kümmert sich der Händler um Bezahlung, Abholung und Abmeldung.</p>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <h3>Gebrauchtwagen verkaufen – mit Sicherheit</h3>
                        <p>Egal, ob du deinen Gebrauchtwagen lokal bei einer Ankaufstation von PKW.de-Partnerhändlern verkaufen möchtest, oder du lieber dein Auto online verkaufst, ohne vom Sofa aufzustehen: bei der Sicherheit musst du keine Abstriche machen. <br/>Denn sowohl bei den lokalen Ankaufstationen als auch beim bequemen Onlineverkauf via Auktion arbeiten wir nur mit geprüften Autohändlern aus ganz Deutschland zusammen. Keine dubiosen Anrufe und lästigen Anrufe. Schon die Genauigkeit der ersten <a href="/auto-verkaufen/auto-bewerten/" title="Preisbewertung">Preisbewertung</a>, die du in <strong>unter 1 Minute erhältst</strong>, hat uns der <strong>TÜV Rheinland</strong> bestätigt. <br/>Und: ob du schlussendlich verkaufen möchtest, bleibt deine freie Entscheidung. Bis du das Kaufangebot der Ankaufstation oder das Höchstgebot aus der Onlineauktion annimmst, kannst du es dir jederzeit anders überlegen und dein Auto behalten. Erst wenn du den Kaufpreis erhältst – bar oder bequem per Überweisung, gibst du Auto, Schlüssel und Papiere ab. Der Händler kümmert sich um die Abmeldung und alles weitere.</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { redirectToEvaluation, redirectToEvaluationNew } from '../services/helpers';
import ContactForm from './ContactForm';

export default {
    name: "ContentBlock",
    components: {
        ContactForm,
    },
    computed: {
        $clientOnly() {
            return typeof window !== 'undefined'; // Checks for browser environment
        }
    },
    methods: {
        makeRedirect(redirectToStation) {        

            if (redirectToStation) {
                redirectToEvaluationNew(this.$store, true, 'trade_in', 'selling_lp');
            } else {
                redirectToEvaluation(this.$store, true, 'sell_car', 'selling_lp');
            }

        },
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/vars";

    .fa.fa-map-marker {
        font-family: 'FontAwesome';
        font-weight: 400;
    }

    h2.headline_h1 {
        margin-bottom:0 !important;
        @include breakpoint(extralarge) {
            font-size: 48px;
            margin-bottom: 72px !important;
        }
    }

    h1,
    h2,
    h3 {
        span {
            display:inline;
        }

        .make-red {
            color: $red;
            display:inline;
            font-size: inherit;
            line-height: inherit;
        }
    }

    .content-wrap .text-wrapper {

        &__btn i {
            padding-left: 10px;
        }
        .text-margin {
            margin-bottom: 30px;
        }

        
    }
    .contact-form-section {
        padding:0;
    }
    .section {
        padding:50px 0;

        @include breakpoint(fromgiant) {
             padding:100px 0;
        }

        
        &.section-highlight {
            background:$light-gray;
        }

        .margin-top {
            margin-top:16px;
            
            @include breakpoint(fromgiant) {
                margin-top:42px;
            }
        }
        .margin-bottom {
            margin-bottom:16px;
            
            @include breakpoint(fromgiant) {
                margin-bottom:42px;
            }
        }

        .image-col {
            display:none;

            @include breakpoint(frommediumlarge) {
                display:block;
            }
        }

        .section-img {
            border-radius: 13px;
        }

        .sub-section {
            margin-top:30px;

            .action-block {
                padding-top:10px;
                display:flex;
                flex-direction: column;
                align-items: center;

                @include breakpoint(fromlarge) {
                    // align-items: flex-start;
                    max-width: 340px;
                    margin-left:60px;
                    margin-top:50px;

                    &.text-only {
                        margin-top:0;
                        margin-left:120px;
                    }
                }

                button {
                    margin-bottom:7px;
                    white-space: nowrap;
                }

                .text-button {
                    text-decoration: underline;
                    color: $black-variant;

                    &:hover {
                        text-decoration: none;
                    }
                }
            }
        }

        .sub-title {
            font-weight: bold;
            font-size: 20px;
            line-height: 30px;
            display:flex;
            align-items:center;
            gap: 10px;
            margin-bottom:10px;

            @include breakpoint(fromlarge) {
                font-size: 34px;
                line-height: 42px;
                margin-bottom:25px;
            }

            i {
                color: $red;
            }
        }

        ul {
            padding:0;
            li {
                position:relative;
                padding-left:25px;
                font-size: 18px;
                line-height: 30px;

                &:before {
                    content: "\f00c";
                    font-family: 'Font Awesome 5 Free';
                    font-weight: 700;
                    display: block;
                    color: $red;
                    font-size: 16px;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
        }

        ol {
            padding-left:0;
            list-style: none;
            counter-reset: my-counter;

            li {
                padding-left:25px;
                counter-increment: my-counter;
                list-style: none;
                position: relative;

                &:before {
                    content: counter(my-counter);
                    background-color: $black-variant;
                    color: $white;
                    font-weight: bold;
                    width: 17px;
                    height: 17px;
                    border-radius: 100%;
                    position:absolute;
                    font-size: 11px;
                    left:0;
                    top:3px;
                    display:flex;
                    align-items:center;
                    justify-content: center;
                }

                &:last-of-type {
                    &:before {
                        content: "\f00c";
                        font-family: 'FontAwesome';
                        font-size:10px;
                        font-weight: normal;
                    }
                }
            }
        }

        .headline_h1 {
            @include breakpoint(fromlarge) {
                text-align:center;
                padding:0;
                
                &:before {
                    display:none;
                }

                
                br {
                    display:none;
                }
            }
        }

        &.content-section-02 {
            .row:last-of-type {
                @include breakpoint(fromlarge) {
                    margin-top:70px;
                }   
            }

            .sub-section {
                &.sub-section-01 {
                    svg {
                        @include breakpoint(fromlarge) {
                            width: 28px;
                            height: 47px;
                        }
                    }
                }

                &.sub-section-02 {
                    svg {
                        @include breakpoint(fromlarge) {
                            width: 51px;
                            height: 46px;
                        }
                    }
                }
            }
        }
    }

    .table.ratings {
        max-width: 910px;
        margin:20px auto 0;

        @include breakpoint(fromlarge) {
            margin:0 auto;
        }
        
        .table-row {
            border-bottom:1px solid #c7c7c7;
            display:flex;

            &:last-of-type {
                border-bottom: 0 none;
            }

            .table-cell {
                flex:1;
                height: 54px;
                display:flex;
                align-items:center;
                justify-content: center;
                border-right: 1px solid #c7c7c7;

                @include breakpoint(fromlarge) {
                    height: 113px;
                    font-size: 24px;
                    line-height: 34px;
                }

                &:last-of-type {
                    border-right:0 none;
                }

                .fa-star {
                    color: #FFD740;

                    @include breakpoint(fromlarge) {
                        font-size: 22px;
                    }
                }
                .fa.fa-star.fa-outlined {
                    font-weight: 400;
                    color:#E7E7E7;
                }

                svg {
                    width: 18px;
                }

                &.head-cell {
                    font-weight: bold;
                    gap: 5px;

                    @include breakpoint(fromlarge) {
                        font-size: 34px;
                        line-height: 34px;
                        gap:15px;
                    }

                    &.local {
                        svg {
                            @include breakpoint(fromlarge) {
                                width: 24px;
                                height: 40px;
                            }
                        }
                    }

                    &.online {
                        svg {
                            @include breakpoint(fromlarge) {
                                width: 43px;
                                height: 34px;
                            }
                        }
                    }
                }

                &.main-cell {
                    flex-direction: column;

                    @include breakpoint(fromlarge) {
                        flex-direction: row;
                        gap:10px;

                        svg {
                            width: 39px;
                            height: 38px;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/station-components/ContentBlock.vue